export class Quizz {
    constructor(listQuestions, responses) {
        this.listQuestions = listQuestions
        this.responses = responses
    }
}
